module.exports = __webpack_public_path__ + "img/yishubao.b779a3e0.png";